const BLOCKED_LINKS = ['fansly.', 'fans.ly', 'weebly.']

export default function catchBlockedLinks(link: string) {
  return BLOCKED_LINKS.some((blockedLink) =>
    link.toLowerCase().includes(blockedLink),
  )
}
